/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed, set } from '@ember/object';

import BaseOptimization from './base-optimization';
import FilterConstants from '../../filter-constants';
import * as PermutationUtils from '../utils/permutation';
import CircuitGroupResults from '../results/circuit-group-results';

export default class VoltageRangeOptimization extends BaseOptimization {
  stopbandFrequency;
  name = FilterConstants.optimizationType.voltageRange;
  @computed('stopbandFrequency') get opAmpRequirementSpecValues() {
    var base = this;
    var stopbandFrequency = base.stopbandFrequency;
    var result = this.getOpAmpRequirementSpecValues(stopbandFrequency);
    return result;
  }

  determineCapacitorValue(stageFp) {
    var startingCapacitor = null;
    if (stageFp < 15.9) {
      // 1/(2*PI*fp* 100kohm) in nF
      startingCapacitor = 1 / (2 * Math.PI * stageFp * 100000);
    } else if (stageFp >= 15.9 && stageFp <= 159) {
      //100 nF
      startingCapacitor = 100 * 1e-9;
    } else if (stageFp >= 159 && stageFp <= 15900) {
      //1/(2*PI*fp* 10kohm) in nF
      startingCapacitor = 1 / (2 * Math.PI * stageFp * 10000);
    } else if (stageFp >= 15900 && stageFp <= 159000) {
      //1 nF
      startingCapacitor = 1 * 1e-9;
    } else {
      //1/(2*PI*fp*1 kohm) in nF
      startingCapacitor = 1 / (2 * Math.PI * stageFp * 1000);
    }

    return startingCapacitor;
  }

  determineStartingR3R4Value(stageFp) {
    var base = this; // to specify which one comes from the base class;
    var rMin = Math.sqrt(100000);
    var rMax = 100000;
    var result = base.processR3R4Value(stageFp, rMin, rMax);
    return result;
  }

  getOpAmpRequirementSpecValues(stopbandFrequency) {
    var base = this; // to specify which one comes from the base class;
    var specs = {
      fMultiplier: 200, //bigger is more strict:  used for highpass
      allowedError: 0.02, //smaller is more strict: used lowpass and bandpass
      rOutFreqMultiplier: 5, //rout shouldn't come into play until 5x stopband
      dcOutputVoltageFromIBias: 0.2,
      stopbandFrequency: stopbandFrequency,
      inductorMultiplier: 4,
    };

    specs.f = stopbandFrequency * specs.rOutFreqMultiplier;

    var result = base.adjustOpAmpRequirementSpecs(specs, stopbandFrequency);

    return result;
  }

  optimizeStageOrder(stages, filterFrequencyRange) {
    //return stages;
    let stageLength = stages.length;
    let permutations = PermutationUtils.permutation(stageLength, stageLength);
    let newFrequencyArray = this.computeOptimizationFrequencyArray(filterFrequencyRange);
    let circuitGroupResults = CircuitGroupResults.create({ actualStages: stages, frequencyArray: newFrequencyArray });
    let optimumPermutation = [];
    let overallMaxSignalInput = 0;
    permutations.forEach((permutation) => {
      set(circuitGroupResults, 'sortOrder', permutation);
      let currentMaxInputSignalPossible = circuitGroupResults.maxInputSignalPossible;

      if (currentMaxInputSignalPossible > overallMaxSignalInput) {
        overallMaxSignalInput = currentMaxInputSignalPossible;
        optimumPermutation = permutation;
      }
    });

    var result = [];
    for (let i = 0; i < optimumPermutation.length; i++) {
      let stage = stages[optimumPermutation[i] - 1];
      set(stage, 'previousStage', null);
      result.push(stage);
    }

    return result;
  }
}
